import { scoreAxisByID, scoreAxisCreate, scoreAxisDestroy, scoreAxisList, scoreAxisUpdate } from '@/services/ventures/score-axes.service'

export default {
	namespaced: true,
	state: {
		scoreAxisList: { meta: { pagination: { total: 0 } } },
		scoreAxis: {},
		scoreAxisStatus: 'pending',
		scoreAxisSaveStatus: 'init',
		scoreAxisDeleteStatus: 'init',
	},
	getters: {
		getScoreAxisList: s => s.scoreAxisList,
		getScoreAxis: s => s.scoreAxis,
		getScoreAxisStatus: s => s.scoreAxisStatus,
		getScoreAxisSaveStatus: s => s.scoreAxisSaveStatus,
		getScoreAxisDeleteStatus: s => s.scoreAxisDeleteStatus,
	},
	mutations: {
		SCORE_AXIS_LIST(state, value) { state.scoreAxisList = value },
		SET_SCORE_AXIS(state, value) { state.scoreAxis = value },
		SCORE_AXIS_STATUS(state, value) { state.scoreAxisStatus = value },
		SCORE_AXIS_SAVE_STATUS(state, value) { state.scoreAxisSaveStatus = value },
		SCORE_AXIS_DELETE_STATUS(state, value) { state.scoreAxisDeleteStatus = value },
	},
	actions: {
		async fetchScoreAxisList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('SCORE_AXIS_STATUS', 'pending')
			commit('SCORE_AXIS_LIST', { meta: { pagination: { total: 0 } } })
			try {
				const { data } = await scoreAxisList(params)
				commit('SCORE_AXIS_STATUS', 'init')
				commit('SCORE_AXIS_LIST', data)
				return data
			} catch (error) {
				commit('SCORE_AXIS_STATUS', 'init')
				throw error
			}
		},
		async saveScoreAxis({ commit }, params) {
			commit('SCORE_AXIS_SAVE_STATUS', 'pending')
			try {
				const { data } = await scoreAxisCreate(params)
				commit('SCORE_AXIS_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('SCORE_AXIS_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateScoreAxis({ commit }, params) {
			commit('SCORE_AXIS_SAVE_STATUS', 'pending')
			try {
				const { data } = await scoreAxisUpdate(params)
				commit('SCORE_AXIS_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('SCORE_AXIS_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteScoreAxisByID({ commit }, params) {
			commit('SCORE_AXIS_DELETE_STATUS', 'pending')
			try {
				const { data } = await scoreAxisDestroy(params)
				commit('SCORE_AXIS_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('SCORE_AXIS_DELETE_STATUS', 'error')
				return error
			}
		},
	},
}
